import { Text } from '@vouched.id/vault';
import React from 'react';
import { JobType } from 'components/account/jobs/job_type';
export const SSNCaption = ({ type }) => {
    switch (type) {
        case JobType.ecbsvSSN:
            return (React.createElement(Text, { style: { marginBottom: '15px' } }, "SSN - ECBSV SSN Verification"));
        case JobType.privateSSN:
            return (React.createElement(Text, { style: { marginBottom: '15px' } }, "SSN - Private SSN Verification"));
    }
};
